<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <!-- Dark Logo-->
    <a routerLink="dashboard" class="logo logo-dark">
      <span class="logo-sm">
        <img src="{{ imageLogo.src }}" alt="" height="35">
      </span>
      <span class="logo-lg">
        <img src="{{ imageLogo.src }}" alt="" height="65">
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="dashboard" class="logo logo-light">
      <span class="logo-sm">
        <img src="{{ imageLogo.src }}" alt="" height="35">
      </span>
      <span class="logo-lg">
        <img src="{{ imageLogo.src }}" alt="" height="65">
      </span>
    </a>
    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover"
      (click)="toggleMobileMenu($event)">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <div id="scrollbar" class="h-100">
    <div class="container-fluid h-100">

      <div id="two-column-menu">
      </div>
      <ngx-simplebar class="sidebar-menu-scroll h-100">
        <ul class="metismenu list-unstyled navbar-nav" id="navbar-nav">

          <!-- Iteramos los items top-level -->
          <ng-container *ngFor="let item of menuItems; let i = index">

            <!-- Si es un título -->
            <li *ngIf="item.isTitle" class="menu-title">
              <span data-key="t-menu">{{ item.label | translate }}</span>
            </li>

            <!-- Si es un link o menú desplegable -->
            <li *ngIf="!item.isTitle" class="nav-item">

              <!-- Ítem con subItems -->
              <ng-container *ngIf="hasItems(item); else singleLink">

                <a href="javascript:void(0);"
                  class="is-parent nav-link menu-link"
                  data-bs-toggle="collapse"
                  [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
                  [attr.aria-expanded]="!item.isCollapsed"
                  (click)="toggleItem(item)">
                  <!-- Icono principal -->
                  <!-- <i *ngIf="item.icon && item.icon!=='gnet'" class="{{ item.icon }} icon nav-icon"></i> -->
                    <!-- *ngIf="item.icon==='gnet'"  -->
                  <img *ngIf="item.icon" class="icon nav-icon custom-icon"
                      [src]="item.icon" alt="gnet">
                  <!-- Texto -->
                  <span>{{ item.label | translate }}</span>
                  <!-- Badge -->
                  <span *ngIf="item.badge" class="badge badge-pill {{item.badge.variant}}">
                    {{ item.badge.text | translate }}
                  </span>
                </a>

                <!-- Collapse Nivel 0 -->
                <div class="collapse menu-dropdown" [(ngbCollapse)]="item.isCollapsed">
                  <ul class="nav nav-sm flex-column">

                    <!-- Nivel 1 -->
                    <ng-container *ngFor="let subitem of item.subItems; let j = index">
                      <li class="nav-item">

                        <!-- Subitem con nietos -->
                        <ng-container *ngIf="hasItems(subitem); else subitemLink">
                          <a href="javascript:void(0);"
                            class="nav-link"
                            data-bs-toggle="collapse"
                            [attr.aria-expanded]="!subitem.isCollapsed"
                            (click)="toggleItem(subitem)">
                            {{ subitem.label | translate }}
                            <span *ngIf="subitem.badge" class="badge badge-pill {{subitem.badge.variant}}">
                              {{ subitem.badge.text | translate }}
                            </span>
                          </a>

                          <!-- Collapse Nivel 1 -->
                          <div class="collapse menu-dropdown sub-menu"
                              [(ngbCollapse)]="subitem.isCollapsed">
                            <ul class="nav nav-sm flex-column">

                              <!-- Nivel 2 -->
                              <ng-container *ngFor="let subSubitem of subitem.subItems; let k = index">
                                <li class="nav-item">

                                  <!-- Con bisnietos -->
                                  <ng-container *ngIf="hasItems(subSubitem); else subSubitemLink">
                                    <a href="javascript:void(0);"
                                      class="nav-link"
                                      data-bs-toggle="collapse"
                                      [attr.aria-expanded]="!subSubitem.isCollapsed"
                                      (click)="toggleItem(subSubitem)">
                                      {{ subSubitem.label | translate }}
                                      <span *ngIf="subSubitem.badge" class="badge badge-pill {{subSubitem.badge.variant}}">
                                        {{ subSubitem.badge.text | translate }}
                                      </span>
                                    </a>

                                    <!-- Collapse Nivel 2 -->
                                    <div class="collapse menu-dropdown extra-sub-menu"
                                        [(ngbCollapse)]="subSubitem.isCollapsed">
                                      <ul class="nav nav-sm flex-column">

                                        <!-- Nivel 3: enlaces finales -->
                                        <ng-container *ngFor="let leaf of subSubitem.subItems; let l = index">
                                          <li class="nav-item">
                                            <a [routerLink]="leaf.link"
                                              class="nav-link"
                                              [class.active]="leaf.isActive"
                                              (click)="updateActive($event, leaf)">
                                              {{ leaf.label | translate }}
                                              <span *ngIf="leaf.badge" class="badge badge-pill {{leaf.badge.variant}}">
                                                {{ leaf.badge.text | translate }}
                                              </span>
                                            </a>
                                          </li>
                                        </ng-container>

                                      </ul>
                                    </div>

                                  </ng-container>

                                  <!-- Nivel 2 sin más hijos -->
                                  <ng-template #subSubitemLink>
                                    <a [routerLink]="subSubitem.link"
                                      class="nav-link"
                                      [class.active]="subSubitem.isActive"
                                      (click)="updateActive($event, subSubitem)">
                                      {{ subSubitem.label | translate }}
                                      <span *ngIf="subSubitem.badge" class="badge badge-pill {{subSubitem.badge.variant}}">
                                        {{ subSubitem.badge.text | translate }}
                                      </span>
                                    </a>
                                  </ng-template>

                                </li>
                              </ng-container>

                            </ul>
                          </div>

                        </ng-container>

                        <!-- Nivel 1 sin subItems -->
                        <ng-template #subitemLink>
                          <a [routerLink]="subitem.link"
                            class="nav-link"
                            [class.active]="subitem.isActive"
                            (click)="updateActive($event, subitem)">
                            {{ subitem.label | translate }}
                            <span *ngIf="subitem.badge" class="badge badge-pill {{subitem.badge.variant}}">
                              {{ subitem.badge.text | translate }}
                            </span>
                          </a>
                        </ng-template>

                      </li>
                    </ng-container>

                  </ul>
                </div>
              </ng-container>

              <!-- Ítem sin subItems -->
              <ng-template #singleLink>
                <a [routerLink]="item.link"
                  class="side-nav-link-ref nav-link menu-link"
                  [class.active]="item.isActive"
                  (click)="updateActive($event, item)">
                  <!-- <i *ngIf="item.icon && item.icon!=='magiis'" class="bx {{ item.icon }} icon nav-icon"></i>
                  *ngIf="item.icon==='magiis'" -->
                  <img *ngIf="item.icon" class="icon nav-icon custom-icon"
                      [src]="item.icon" alt="magiis">
                  <span>{{ item.label | translate }}</span>
                  <span *ngIf="item.badge" class="badge badge-pill {{item.badge.variant}}">
                    {{ item.badge.text | translate }}
                  </span>
                </a>
              </ng-template>

            </li>
          </ng-container>

        </ul>




      </ngx-simplebar>
    </div>
    <!-- Sidebar -->
  </div>
  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>